export * from '@taqueria/protocol/out/types/ConfigFileV2';
